import React, { useCallback } from 'react';

import TextArea from '../../components/TextArea';
import ReactMarkdown from 'react-markdown'


function DescriptionElementForm({ element, onChange }) {
  const handleChangeLabel = useCallback(e => {
    onChange({
      ...element,
      data: {
        ...element.data,
        label: e.target.value
      }
    });
  }, [element, onChange]);

  return (
    <>
    <TextArea
      defaultValue={element.data.label}
      onBlur={handleChangeLabel}
    />
    <ReactMarkdown skipHtml={true} children={element.data.label}/>
  </>
  );
}

export default DescriptionElementForm;